import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { Stream } from 'src/models/stream';
import { PlayerService } from 'src/app/services/player.service';
import { UserService } from 'src/app/services/user.service';
import { FormResponse } from 'src/models/form-response';
import { AccountService } from 'src/app/services/account.service';
import { ToastrService } from 'ngx-toastr';
import { FormResponseError } from 'src/models/form-response-error';
import { Episode } from 'src/models/episode';
import { Router } from '@angular/router';

declare var MediaElement: any;

@Component({
  selector: 'app-player',
  templateUrl: './player.component.html',
  styleUrls: ['./player.component.scss']
})
export class PlayerComponent implements OnInit {

  public mediaElement: any;

  public currentStream: Stream;
  public playlist = new Array<Stream>();

  public buffering = false;
  public isPlaying = false;
  public muted = false;
  public currentVolume = 0.5;
  public currentTime: number;
  public duration: number;
  public percentagePlayed: number;

  public isFavorite = false;

  public errorMessage: string;

  private lastStreamUrl: string;

  constructor(private playerService: PlayerService,
              private userService: UserService,
              private accountService: AccountService,
              private toastr: ToastrService,
              private router: Router) {
    playerService.currentStream.subscribe((stream: Stream) => {

      const exists = this.playlist.find((streamInPlaylist: Stream) => streamInPlaylist.id === stream.id) !== undefined;

      if (!exists) {
        this.playlist.push(stream);
      }

      this.invokePlay(stream);

      this.isFavorite = this.userService.getFavorites().getValue().find((tempStream: Stream) => {
        const streamId = stream instanceof Episode ? stream.podcast.id : stream.id;

        return tempStream.id === streamId;
      }) !== undefined;
    });

    playerService.invokePause.subscribe(() => {
      this.pause();
    });

    this.userService.getFavorites().subscribe((streams: Stream[]) => {
      if (this.currentStream !== undefined) {
        this.isFavorite = this.userService.getFavorites().getValue()
                            .find((tempStream: Stream) => {
                              const streamId = this.currentStream instanceof Episode ? this.currentStream.podcast.id : this.currentStream.id;

                              return tempStream.id === streamId;
                            }) !== undefined;
      }
    });
  }

  ngOnInit() {
    this.mediaElement = new MediaElement('me_player', {
      pluginPath: 'https://cdnjs.com/libraries/mediaelement/',
        // this will allow the CDN to use Flash without restrictions
        // (by default, this is set as `sameDomain`)
        shimScriptAccess: 'always',
        startVolume: this.currentVolume
    });

    this.mediaElement.addEventListener('error', this.errorListener.bind(this));
    this.mediaElement.addEventListener('playing', this.playingListener.bind(this));
    this.mediaElement.addEventListener('pause', this.pauseListener.bind(this));
    this.mediaElement.addEventListener('volumechange', this.volumeChangeListener.bind(this));
    this.mediaElement.addEventListener('timeupdate', this.timeUpdateListener.bind(this));
  }

  public invokePlay(stream: Stream) {

    if (this.isPlaying !== this.playerService.isPlaying.value) {
      this.playerService.setPlaying(true);
    }

    this.currentStream = stream;
    this.errorMessage = undefined;

    if (stream instanceof Episode) {
        this.lastStreamUrl = stream.url;
        this.mediaElement.setSrc(stream.url);
        this.buffering = true;
        this.mediaElement.play();
    } else {
      this.playerService.getStreamUrls(stream).subscribe((urls: string[]) => {

        if (urls !== null) {
          this.lastStreamUrl = urls[0];
          this.mediaElement.setSrc(urls[0]);
          this.buffering = true;
          this.mediaElement.play();
        }
      });
    }
  }

  public play() {
    this.errorMessage = undefined;

    this.buffering = true;
    this.mediaElement.play();
  }

  public pause() {
    this.mediaElement.pause();
  }

  public mute() {
    this.mediaElement.setMuted(true);
    this.muted = true;
  }

  public unmute() {
    this.mediaElement.setMuted(false);
    this.muted = false;
  }

  public changeVolume(event: MouseEvent) {
    const volume = event.offsetX / event.target['offsetWidth'];

    this.mediaElement.setVolume(volume);
  }

  public seek(event: MouseEvent) {
    const value = event.offsetX / event.target['offsetWidth'];

    console.log('seek', value);
    //this.mediaElement.setVolume(volume);

    this.mediaElement.currentTime = value * this.mediaElement.duration;
  }

  public playPrevious() {
      const currentIndex = this.playlist.findIndex((stream: Stream) => stream === this.currentStream);

      if (currentIndex > 0) {
        this.invokePlay(this.playlist[currentIndex - 1]);
      }
  }

  public playNext() {
      const currentIndex = this.playlist.findIndex((stream: Stream) => stream === this.currentStream);

      if (currentIndex +1 < this.playlist.length) {
        this.invokePlay(this.playlist[currentIndex + 1]);
      }
  }

  public removeFromPlaylist(stream: Stream) {
      this.playlist = this.playlist.filter((value: Stream) => value !== stream);

      if (stream === this.currentStream) {
        this.currentStream = undefined;
        this.lastStreamUrl = undefined;
        this.mediaElement.pause();
      }
  }

  public errorListener(e: CustomEvent) {
    this.errorMessage = e['message'];
    this.buffering = false;

    if (this.isPlaying && this.playerService.isPlaying.value === true) {
      this.playerService.setPlaying(false);
    }
  }

  public playingListener() {
    this.isPlaying = true;
    this.buffering = false;

    if (this.isPlaying !== this.playerService.isPlaying.value) {
      this.playerService.setPlaying(true);
    }

    this.mediaElement.setMuted(this.muted);
  }

  public pauseListener(e: object) {
    this.buffering = false;

    if (this.isPlaying && this.playerService.isPlaying.value === true) {
      this.playerService.setPlaying(false);
    }

    this.isPlaying = false;
  }

  public volumeChangeListener(e: object) {

    this.currentVolume = this.mediaElement.getVolume();
  }

  public timeUpdateListener(data: object) {
    this.currentTime = !isNaN(this.mediaElement.currentTime) ?  this.mediaElement.currentTime * 1000 : undefined;
    this.duration = this.mediaElement.duration != Infinity && !isNaN(this.mediaElement.duration) ?  this.mediaElement.duration * 1000 : undefined;

    this.percentagePlayed = this.duration !== undefined ? (this.currentTime / this.duration) * 100 : 0;
  }

  public toggleFavorite() {

    if (this.accountService.loggedInUser.getValue() === undefined) {
      this.toastr.error('Du musst eingeloggt sein, um diese Aktion auszuführen.', 'Fehler');
    } else {
      const observable = !this.isFavorite ?
                              this.userService.addToFavorites(this.currentStream) :
                              this.userService.removeFromFavorites(this.currentStream);

      const isFavorite = !this.isFavorite;

      observable.subscribe((formResponse: FormResponse) => {
        const favoriteTypeLabel = this.currentStream.type === 'podcast' ? 'Podcast' : 'Sender';

        if (formResponse.result) {
          if (isFavorite) {
            this.toastr.success('Der ' + favoriteTypeLabel + ' wurde hinzugefügt.');
          } else {
            this.toastr.success('Der ' + favoriteTypeLabel + ' wurde entfernt.');
          }
        } else {
          let errorText = 'Es ist ein Fehler aufgetreten.';

          if (formResponse.errors !== undefined) {
            const errors = formResponse.errors.filter((error: FormResponseError) => {
              return error.field === 'default';
            });

            if (errors.length > 0) {
              errorText = '';

              errors.forEach((error: FormResponseError) => {
                if (errorText.length > 0) errorText += '<br />';

                errorText += error.msg;
              })
            }
          }

          this.toastr.error(errorText, 'Fehler');
        }

      });
    }
  }

  public isEpisode() {
    return this.currentStream instanceof Episode;
  }

  public onTitleClicked() {
    if (this.currentStream instanceof Episode) {
      this.router.navigate(['/podcast/' + this.currentStream.podcast.id], { state: { autoplay: false } });
    }
  }

}
